export class TargetSet {
  constructor(context) {
    this.context = context;
  }

  get element() {
    return this.context.element;
  }

  get identifier() {
    return this.context.identifier;
  }

  get schema() {
    return this.context.schema;
  }

  has(targetName) {
    return this.find(targetName) != null;
  }

  find(...targetNames) {
    const selector = this._getSelectorForTargetNames(targetNames);

    return this.context.getElement(selector);
  }

  findAll(...targetNames) {
    const selector = this._getSelectorForTargetNames(targetNames);

    return this.context.getElements(selector);
  }

  _getSelectorForTargetNames(targetNames) {
    return targetNames.map(targetName => this._getSelectorForTargetName(targetName)).join(', ');
  }

  _getSelectorForTargetName(targetName) {
    const targetDescriptor = "".concat(this.identifier, ".").concat(targetName);
    return attributeValueContainsToken(this.schema.elAttribute, targetDescriptor);
  }

}

function attributeValueContainsToken(attributeName, token) {
  return "[".concat(attributeName, "~=\"").concat(token, "\"]");
}